import { Header } from "../components/Header";
import { HeroSection } from "../components/HeroSection";
import { ServicesSection } from "../components/ServicesSection";
import { DoctorSection } from "../components/DoctorSection";
import { TestimonialsSection } from "../components/TestimonialsSection";
import { LocationsSection } from "../components/LocationsSection";
import { TextToBookSection } from "../components/TextToBookSection";
import { AmenitiesSection } from "../components/AmenitiesSection";
import { NewsSection } from "../components/NewsSection";
import { Footer } from "../components/Footer";

import { GongjindanSection } from "../components/GongjindanSection";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:z-[100] focus:top-4 focus:left-4 focus:bg-teal-700 focus:text-white focus:px-4 focus:py-2 focus:rounded-lg focus:text-sm focus:font-medium"
      >
        Skip to main content
      </a>
      <Header />
      <main id="main-content">
        <HeroSection />
        <ServicesSection />
        <GongjindanSection />
        <DoctorSection />
        <TestimonialsSection />
        <LocationsSection />
        <TextToBookSection />
        <AmenitiesSection />
        <NewsSection />
      </main>
      <Footer />
    </div>
  );
}
